import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * @typedef {('upcoming'|'cancelled'|'completed')} TabId
 */

const Appointment = () => {
  const navigate = useNavigate(); // ✅ add useNavigate hook

  /**
   * State to track the currently active tab.
   * @type {[TabId, React.Dispatch<React.SetStateAction<TabId>>]}
   */
  const [activeTab, setActiveTab] = useState('upcoming');

  const handleBookClick = () => {
    // Redirect to /shop-detail
    navigate('/shop-detail');
  };

  const tabs = [
    { id: 'upcoming', label: 'Upcoming' },
    { id: 'cancelled', label: 'Cancelled' },
    { id: 'completed', label: 'Completed' },
  ];

  const tabContent = {
    upcoming: <div className="text-center text-gray-500 text-lg sm:text-xl py-10">Coming Soon 🚀</div>,
    cancelled: <div className="text-center text-gray-500 text-lg sm:text-xl py-10">Coming Soon 🚀</div>,
    completed: <div className="text-center text-gray-500 text-lg sm:text-xl py-10">Coming Soon 🚀</div>,
  };

  return (
    <div className="bg-[#FFF6F1] min-h-screen p-4 sm:p-6 lg:p-8 flex flex-col">
      <header className="mb-6 flex justify-between items-center">
        <h1 className="text-3xl font-extrabold text-[#1B4582]">My Appointments</h1>
        <button
          onClick={handleBookClick}
          className="hidden sm:inline-flex px-4 py-2 bg-orange-500 text-white rounded-lg font-semibold hover:bg-orange-600 transition shadow-md"
        >
          Book New Appointment
        </button>
      </header>

      <nav className="w-full flex flex-row gap-2 sm:gap-3 mb-6 justify-start" role="tablist">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`px-4 py-2.5 font-semibold rounded-md text-base sm:text-lg transition duration-150 ${
              activeTab === tab.id
                ? 'bg-[#1B4582] text-white shadow-md'
                : 'bg-gray-200 text-[#1B4582] hover:bg-gray-300'
            }`}
            role="tab"
            id={`tab-${tab.id}`}
            aria-selected={activeTab === tab.id}
            aria-controls={`panel-${tab.id}`}
          >
            {tab.label}
          </button>
        ))}
      </nav>

      <section
        id={`panel-${activeTab}`}
        role="tabpanel"
        aria-labelledby={`tab-${activeTab}`}
        className="bg-white rounded-xl shadow-md p-6 sm:p-8 w-full mx-auto"
      >
        {tabContent[activeTab]}
      </section>
    </div>
  );
};

export default Appointment;
